import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MoveRelatedApiModel, PeFormQuestionApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PpFormQuestionsService {
  public url = 'pp-form-questions';

  constructor(private readonly http: HttpClientService) {}

  public add(model: PeFormQuestionApiModel): Observable<PeFormQuestionApiModel> {
    return this.http.post<PeFormQuestionApiModel>(`${this.url}/add`, model);
  }

  public update(model: PeFormQuestionApiModel): Observable<PeFormQuestionApiModel> {
    return this.http.put<PeFormQuestionApiModel>(`${this.url}/update`, model);
  }

  public delete(id: number): Observable<Object> {
    return this.http.delete(`${this.url}/delete/${id}`);
  }

  public move(model: MoveRelatedApiModel<number, number>): Observable<void> {
    return this.http.put<void>(`${this.url}/move`, model);
  }
}
